import React from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import ProgressHeading from "components/views/ProgressHeading";
import EndOfPageNotes from "components/views/EndOfPageNotes";
import OutlinedMoreHelp from "components/views/OutlinedMoreHelp";
import OutlinedLinksGrid from "components/views/OutlinedLinksGrid";
import EngineModelList from "components/containers/EngineModelList";
import Footer from "components/views/atoms/Footer";

const SpecificationGroup = ({ className, breadcrumbs }) => {
  const classes = ["SpecificationGroup"];
  if (className) classes.push(className);
  const bc = breadcrumbs.map((b) => b());

  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="common.productSelector" />
      </PageHeading>

      <Row fullWidth>
        <ProgressHeading
          perc={60}
          heading={T({ path: "specificationGroupPage.progressHeading" })}
          breadcrumbSteps={bc}
        />
      </Row>

      <Row>
        <EngineModelList />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedMoreHelp LinkLabel={T({ path: "button.moreHelpUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row>
        <EndOfPageNotes />
      </Row>

      <Footer />
    </OneCol>
  );
};

SpecificationGroup.displayName = "SpecificationGroup";

SpecificationGroup.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.func),
};

SpecificationGroup.defaultProps = {
  className: null,
  breadcrumbs: [],
};

export default SpecificationGroup;
